<div class="modal-header">
  <h5 class="modal-title">{{ title }}</h5>
              <button type="button" class="close" aria-label="Close" (click)="cancel()">
                <span aria-hidden="true">&times;</span>
            </button>
</div>

<div class="modal-body">

  <div class="row">
    <div
      class="col-6 mb-2"
      *ngFor="let shift of turnos"
    >
      <div
        class="card shift-option"
        [ngStyle]="{ 'background-color': shift.color || '#f8f9fa' }"
        [ngClass]="{ 'selected': selectedShift?.id === shift.id }"
        (click)="selectShift(shift)"
      >
        <div class="card-body text-center py-2">

          <div class="font-weight-bold">
            {{ shift.start }} - {{ shift.end }}
          </div>

          <div *ngIf="shift.name" class="font-small-1">
            {{ shift.name }}
          </div>

        </div>
      </div>
    </div>
  </div>

</div>

<div class="modal-footer">
  <button class="btn btn-secondary" (click)="cancel()">
    Cancelar
  </button>

  <button
    class="btn btn-primary"
    [disabled]="!selectedShift"
    (click)="confirm()"
  >
    Asignar
  </button>
</div>
